import { component } from 'picoapp';
import $ from 'jquery';
import str2json from '../../utils/str2json';
import getClosest from '../../utils/getClosest';
import delegate from 'delegate';
// const simpleLightbox = require('simplelightbox');
const Flickity = require('flickity');

class ProductGallery {
  constructor(el, ctx) {
    this.ctx = ctx;
    this.init(el);
    this.initSliders();
  }

  init(el) {
    this.el = el;
    this.mainSliderEl = this.el.querySelector('.mainImage');
    this.thumbsSliderEl = this.el.querySelector('.product-thumbs .wrapper');
    this.statusCurrent = this.el.querySelector('.Gallery__status .current');
    this.statusTotal = this.el.querySelector('.Gallery__status .total');
    this.parentController = getClosest(el, '.Modal');
    this.nextButton = this.el.querySelector('.next');
    this.prevButton = this.el.querySelector('.previous');

    this.scrapsThumbs = this.el.querySelector('.product-scraps-thumbs .wrapper')
  }

  initSliders() {
    var defaults = {
      pageDots: false,
      cellAlign: 'center',
      imagesloaded: true,
      wrapAround: true,
      selectedAttraction: 0.01,
      friction: 0.15,
      arrowShape:
        'M24.7552323,51.4875645 C23.7482559,50.3911482 23.7482559,48.6150532 24.7552323,47.518637 L65.6194256,2.82355245 C66.1183779,2.27286376 66.7760878,2 67.4337976,2 C68.0915075,2 68.7446814,2.27286376 69.2481696,2.82355245 C70.2506101,3.91996867 70.2506101,5.70102487 69.2481696,6.79744109 L30.2028843,49.5031007 L69.2481696,92.2037992 C70.2506101,93.3002154 70.2506101,95.0812716 69.2481696,96.1776878 C68.2457291,97.2741041 66.6173302,97.2741041 65.6148897,96.1776878 L24.7552323,51.4875645 Z'
    };
    const mainSliderOptions = {
      prevNextButtons: false
    };
    const thumbsSliderOptions = {
      prevNextButtons: false,
      cellAlign: 'right',
      wrapAround: true,
      draggable: false
    };

    const customOptions = str2json(this.el.dataset.options);

    this.mainSlider = new Flickity(this.mainSliderEl, {
      ...defaults,
      ...mainSliderOptions,
      ...customOptions
    });

    if (this.thumbsSliderEl) {
      this.thumbsSlider = new Flickity(this.thumbsSliderEl, {
        ...defaults,
        ...thumbsSliderOptions,
        ...customOptions
      });
    }

    this.bindEvents();
    this.updateStatus();

    if (this.thumbsSliderEl) {
      this.initCustomSliderUI(this.thumbsSliderEl, this.thumbsSlider);
    }

    if (this.scrapsThumbs) {
      this.initCustomSliderUI(this.scrapsThumbs, this.mainSlider);
    }
  }

  bindEvents() {
    if (this.thumbsSlider) {
      this.thumbsSlider.on('change', (index, pointer) => {
        this.mainSlider.select(index);
      });
    }

    this.mainSlider.on('dragStart', function (event, pointer) {
      document.ontouchmove = function (e) {
        e.preventDefault();
      }
    });

    this.mainSlider.on('dragEnd', function (event, pointer) {
      document.ontouchmove = function (e) {
        return true;
      }
    });

    this.mainSlider.on('change', (index, pointer) => {
      if (this.thumbsSlider) {
        this.thumbsSlider.select(index);
      }
      this.updateStatus();
    });

    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => {
        this.mainSlider.previous();
      });
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        this.mainSlider.next();
      });
    }

    if (this.parentController) {
      this.parentController.addEventListener('isActive', () => {
        this.mainSlider.resize();
      });
    }
  }

  updateStatus() {
    let currentIndex = this.mainSlider.selectedIndex + 1;
    let totalSlides = this.mainSlider.cells.length;

    if (this.statusCurrent) {
      this.statusCurrent.innerText = currentIndex;
    }
    if (this.statusTotal) {
      this.statusTotal.innerText = totalSlides;
    }
  }

  initCustomSliderUI(containerEl, slider) {
    // const cellsButtonGroup = containerEl;
    const cellsButtons = [].slice.call(containerEl.querySelectorAll('.item'));
    // console.log(cellsButtons);
    // return;
    // update buttons on select
    // slider.on('cellSelect', (index) => {
    //   var previousSelectedButton = cellsButtonGroup.querySelector(
    //     '.is-selected'
    //   );
    //   var selectedButton = cellsButtonGroup.children[slider.selectedIndex];
    //   previousSelectedButton.classList.remove('is-selected');
    //   selectedButton.classList.add('is-selected');
    // });
    // cell select
    cellsButtons.forEach((el, index) => {
      el.addEventListener('click', (e) => {
        slider.select(index);
      });
    });
  }
}

// export default ProductGallery;
export default component((node, ctx) => {
  new ProductGallery(node, ctx);
});
